const getters = {
  routes: state => state.permission.routes,
  leftMenu: state => state.leftMenu.leftMenu,
  basePath: state => state.leftMenu.basePath,
  isContentReload:state => state.reload.isContentReload,
  isRightReload:state => state.reload.isRightReload,
  token:state => state.user.token,
  name:state => state.user.name,
  roles:state => state.user.roles,
  stores:state => state.user.stores,
  shopCode:state => state.user.shopCode,
  navTab:state => state.navTab.navTab,
  catch_components:state => state.catchComponents.catch_components,
  selectFirstArray:state => state.disableSelectTree.selectFirstArray,
  selectSecondArray:state => state.disableSelectTree.selectSecondArray,
  selectThirdArray:state => state.disableSelectTree.selectThirdArray,
  isFromPlugin:state => state.plugin.isFromPlugin,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js